import { useQuery } from "@tanstack/react-query";
import { getMyPortfolioStats } from "features/collections/api/nftCollectionApi";
// Сводная статистика профиля (NFT/на продаже/офферы/транзакции/рост портфеля).
// Отдельный лёгкий запрос; держим свежим 30с, чтобы не дёргать на каждый ререндер.
function useProfileStats() {
    return useQuery({
        queryKey: ["me-portfolio-stats"],
        queryFn: getMyPortfolioStats,
        staleTime: 30000,
    });
}
export default useProfileStats;
